module.exports = __webpack_public_path__ + "img/errImgMsg.8b731a7a.svg";